function initTrustmarksAccrediationsMarquee() {
  if (!window.ResillionTrustmarkMarquee) return;

  document
    .querySelectorAll(".trustmarks-acreds [data-trustmarks-marquee]")
    .forEach((marquee) => {
      window.ResillionTrustmarkMarquee.init(marquee);
    });
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    initTrustmarksAccrediationsMarquee,
    { once: true },
  );
} else {
  initTrustmarksAccrediationsMarquee();
}
